// src/utils/faqToggle.js
export const initFAQToggles = () => {
  const faqItems = document.querySelectorAll('.faq-item');

  faqItems.forEach((item) => {
    const btn = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');

    btn.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      //alert('clicked');

      // Close all other open FAQs
      faqItems.forEach((el) => {
        el.classList.remove('open');
        el.querySelector('.faq-answer').classList.remove('show');
      });

      // Toggle current
      if (!isOpen) {
        item.classList.add('open');
        answer.classList.add('show');
      }
    });
  });
};
